import { get } from "./HttpClient"
import { API_RESET_PASSWORD } from "./ApisRoutes";

export const ResetPasswordService = (email, locale) => {
    const api = API_RESET_PASSWORD+"?eMail="+email+"&locale="+locale;
    return new Promise((resolve, reject) => {
        get(api).then(response => {
            resolve(response?.data);
        }).catch(error => {
            console.error("reset error", error);
            reject(error);
        });
    });
}
